// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"6575373d","37":"8ae11f72","171":"d30bcd99","429":"6f0d8bf0","456":"18171528","507":"10bd6e54"}[chunkId] + ".chunk.js";
};